// Funkce pro kontrolu množství
function checkStep(input, incrementButton, decrementButton) {
	const quantityInput = input;
	const step = parseInt(quantityInput.step) || 1;

	// Funkce pro zaokrouhlení na nejbližší násobek
	function roundToStep(value, step) {
		return Math.round(value / step) * step;
	}

	function updateQuantity(newValue) {
		quantityInput.value = newValue;
		check();
	}

	function check() {
		const quantity = parseInt(quantityInput.value);
		const closestStep = roundToStep(quantity, step);
		if (quantity !== closestStep) {
			updateQuantity(closestStep);
		}
	}

	input.addEventListener('change', check);

	// Přidejte funkcionalitu pro přidávání a ubírání
	incrementButton.addEventListener('click', () => {
		const currentValue = parseInt(quantityInput.value);
		const newValue = currentValue + step;
		updateQuantity(newValue);
	});

	decrementButton.addEventListener('click', () => {
		const currentValue = parseInt(quantityInput.value);
		if (currentValue >= step) {
			const newValue = currentValue - step;
			updateQuantity(newValue);
		}
	});

	// Zavolání check při načtení stránky pro počáteční kontrolu
	check();
}

document.addEventListener('DOMContentLoaded', () => {
// Najdeme všechny prvky s třídou "quantity-input" a aplikujeme funkci checkStep na každý z nich
	const quantityInputs = document.querySelectorAll('.spinner');
	quantityInputs.forEach((wrapper, index) => {
		const incrementButton = wrapper.querySelector('.increment');
		const decrementButton = wrapper.querySelector('.decrement');
		const input = wrapper.querySelector('input[type="number"]');

		input && checkStep(input, incrementButton, decrementButton);
	});
})
